export const API_URL = process.env.VUE_APP_ROOT_API;
export default API_URL;
